import React, { Fragment } from "react";
import { DropdownItem } from "reactstrap";
import { getUserRole } from "../../../Services/Shared.service";
import { Admin } from "../../../Data/SideMenu/RouteMapping";

const QuickActions = ({
  setDriverObj,
  element,
  toggleAssignBookingModal,
  toggleLocateDriverModal,
  toggleNotifyDriverModal,
  toggleResetDriverModal,
  toggleBlockDriverModal,
  toggleUnblockModal,
  setEditId,
  toggleCreateDriverModal,
  toggleDeleteModal,
  toggleRechargeModal
}) => {
  const userRole = getUserRole();
  return (
    <Fragment>
      <DropdownItem
        className="border-0"
        key={"row-edit"}
        onClick={() => {
          setEditId(element.id);
          toggleCreateDriverModal();
        }}
      >
        <i className="fa fa-pencil"></i> Edit
      </DropdownItem>
      <DropdownItem
        className="border-0"
        key={"row-edit"}
        onClick={() => {
          setDriverObj(element);
          toggleAssignBookingModal();
        }}
        disabled={element.isAvailable ? false : true}
      >
        <i className="fa fa-user-plus"></i> Assign Trip
      </DropdownItem>
      <DropdownItem
        className="border-0"
        key={"row-cancel"}
        onClick={() => {
          setDriverObj(element);
          toggleLocateDriverModal();
        }}
      >
        <i className="fa fa-map-marker"></i> Locate
      </DropdownItem>
      <DropdownItem
        className="border-0"
        key={"row-notify"}
        onClick={() => {
          setDriverObj(element);
          toggleNotifyDriverModal();
        }}
      >
        <i className="fa fa-bell"></i> Notify
      </DropdownItem>
      <DropdownItem
        className="border-0"
        key={"row-block"}
        onClick={() => {
          setDriverObj(element);
          if (element.isAvailable) {
            toggleBlockDriverModal();
          }
          else {
            toggleUnblockModal()
          }
        }}
      >
        <i className="fa fa-ban"></i>{element.isAvailable ? "Block" : "Unblock"}
      </DropdownItem>
      <DropdownItem
        className="border-0"
        key={"row-reset"}
        onClick={() => {
          setDriverObj(element);
          toggleResetDriverModal();
        }}
      >
        <i className="fa fa-refresh"></i> Reset login
      </DropdownItem>
      <DropdownItem
        className="border-0"
        key={"row-edit"}
        onClick={() => {
          setDriverObj(element);
          toggleRechargeModal()
        }}
      >
        <i className="fa fa-rupee"></i> Recharge
      </DropdownItem>
      {userRole.some((element) =>  element == Admin) ? <DropdownItem
        className="border-0"
        key={"row-edit"}
        onClick={() => {
          setDriverObj(element);
          toggleDeleteModal()
        }}
      >
        <i className="fa fa-trash"></i> Delete
      </DropdownItem> : null}
    </Fragment>
  );
};

export default QuickActions;
